import { render, staticRenderFns } from "./reporteRequisiciones.vue?vue&type=template&id=513a77b4"
import script from "./reporteRequisiciones.vue?vue&type=script&lang=js"
export * from "./reporteRequisiciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports